import { RuleResult } from '../../../../types/DeclarationP5'

const C0186Validator = {
  validateConsignmentTransportChargesRequirement: ({
    security,
  }: {
    security: string
  }): RuleResult => (security === '0' ? 'NOT_ALLOWED' : 'OPTIONAL'),
  validateHouseConsignmentTransportChargesRequirement: ({
    security,
  }: {
    security: string
  }): RuleResult => (security === '0' ? 'NOT_ALLOWED' : 'OPTIONAL'),
}

export default C0186Validator
